
// 面试题内容编辑提交
import request from '@/utils/request.js'

// 编辑提交
export const bankEdit=(editData)=>{
    return request.post(
        '/questionBand/questionBandEdit',
        editData
    )
}